/** Detect Golf Homes client views for themed portal experiences. */
export function isGolfHomesView(view) {
  if (!view) return false;
  const slug = String(view.slug || "").toLowerCase();
  const type = String(view.viewType || view.view_type || "").toLowerCase();
  const name = String(view.name || "").toLowerCase();
  return (
    type === "golf_homes" ||
    slug.includes("golf-homes") ||
    slug.includes("golf_homes") ||
    name.includes("golf homes")
  );
}
